import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module table/tableproperties/ui/tablepropertiesview
 */
import { addListToDropdown, ButtonView, createLabeledDropdown, createLabeledInputText, FocusCycler, FormHeaderView, LabeledFieldView, LabelView, submitHandler, ToolbarView, View, ViewCollection } from 'ckeditor5/src/ui.js';
import { FocusTracker, KeystrokeHandler } from 'ckeditor5/src/utils.js';
import { icons } from 'ckeditor5/src/core.js';
import { fillToolbar, getBorderStyleDefinitions, getBorderStyleLabels, getLabeledColorInputCreator } from '../../utils/ui/table-properties.js';
import FormRowView from '../../ui/formrowview.js';
import '../../../theme/form.css';
import '../../../theme/tableform.css';
import '../../../theme/tableproperties.css';
var ALIGNMENT_ICONS = {
  left: icons.objectLeft,
  center: icons.objectCenter,
  right: icons.objectRight
};
/**
 * The class representing a table properties form, allowing users to customize
 * certain style aspects of a table, for instance, border, background color, alignment, etc..
 */
var TablePropertiesView = /*#__PURE__*/function (_View) {
  _inherits(TablePropertiesView, _View);
  var _super = _createSuper(TablePropertiesView);
  /**
   * @param locale The {@link module:core/editor/editor~Editor#locale} instance.
   * @param options Additional configuration of the view.
   */
  function TablePropertiesView(locale, options) {
    var _this;
    _classCallCheck(this, TablePropertiesView);
    _this = _super.call(this, locale);
    _this.set({
      borderStyle: '',
      borderWidth: '',
      borderColor: '',
      backgroundColor: '',
      width: '',
      height: '',
      alignment: ''
    });
    _this.options = options;
    var _this$_createBorderFi = _this._createBorderFields(),
      borderStyleDropdown = _this$_createBorderFi.borderStyleDropdown,
      borderWidthInput = _this$_createBorderFi.borderWidthInput,
      borderColorInput = _this$_createBorderFi.borderColorInput,
      borderRowLabel = _this$_createBorderFi.borderRowLabel;
    var _this$_createBackgrou = _this._createBackgroundFields(),
      backgroundRowLabel = _this$_createBackgrou.backgroundRowLabel,
      backgroundInput = _this$_createBackgrou.backgroundInput;
    var _this$_createDimensio = _this._createDimensionFields(),
      widthInput = _this$_createDimensio.widthInput,
      operatorLabel = _this$_createDimensio.operatorLabel,
      heightInput = _this$_createDimensio.heightInput,
      dimensionsLabel = _this$_createDimensio.dimensionsLabel;
    var _this$_createAlignmen = _this._createAlignmentFields(),
      alignmentToolbar = _this$_createAlignmen.alignmentToolbar,
      alignmentLabel = _this$_createAlignmen.alignmentLabel;
    _this.focusTracker = new FocusTracker();
    _this.keystrokes = new KeystrokeHandler();
    _this.children = _this.createCollection();
    _this.borderStyleDropdown = borderStyleDropdown;
    _this.borderWidthInput = borderWidthInput;
    _this.borderColorInput = borderColorInput;
    _this.backgroundInput = backgroundInput;
    _this.widthInput = widthInput;
    _this.heightInput = heightInput;
    _this.alignmentToolbar = alignmentToolbar;
    // Defer creating to make sure other fields are present and the Save button can
    // bind its #isEnabled to their error messages so there's no way to save unless all
    // fields are valid.
    var _this$_createActionBu = _this._createActionButtons(),
      saveButtonView = _this$_createActionBu.saveButtonView,
      cancelButtonView = _this$_createActionBu.cancelButtonView;
    _this.saveButtonView = saveButtonView;
    _this.cancelButtonView = cancelButtonView;
    _this._focusables = new ViewCollection();
    _this._focusCycler = new FocusCycler({
      focusables: _this._focusables,
      focusTracker: _this.focusTracker,
      keystrokeHandler: _this.keystrokes,
      actions: {
        // Navigate form fields backwards using the Shift + Tab keystroke.
        focusPrevious: 'shift + tab',
        // Navigate form fields forwards using the Tab key.
        focusNext: 'tab'
      }
    });
    // Form header.
    _this.children.add(new FormHeaderView(locale, {
      label: _this.t('Table properties')
    }));
    // Border row.
    _this.children.add(new FormRowView(locale, {
      labelView: borderRowLabel,
      children: [borderRowLabel, borderStyleDropdown, borderColorInput, borderWidthInput],
      class: 'ck-table-form__border-row'
    }));
    // Background row.
    _this.children.add(new FormRowView(locale, {
      labelView: backgroundRowLabel,
      children: [backgroundRowLabel, backgroundInput],
      class: 'ck-table-form__background-row'
    }));
    _this.children.add(new FormRowView(locale, {
      children: [
      // Dimensions row.
      new FormRowView(locale, {
        labelView: dimensionsLabel,
        children: [dimensionsLabel, widthInput, operatorLabel, heightInput],
        class: 'ck-table-form__dimensions-row'
      }),
      // Alignment row.
      new FormRowView(locale, {
        labelView: alignmentLabel,
        children: [alignmentLabel, alignmentToolbar],
        class: 'ck-table-properties-form__alignment-row'
      })]
    }));
    // Action row.
    _this.children.add(new FormRowView(locale, {
      children: [_this.saveButtonView, _this.cancelButtonView],
      class: 'ck-table-form__action-row'
    }));
    _this.setTemplate({
      tag: 'form',
      attributes: {
        class: ['ck', 'ck-form', 'ck-table-form', 'ck-table-properties-form'],
        // https://github.com/ckeditor/ckeditor5-link/issues/90
        tabindex: '-1'
      },
      children: _this.children
    });
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(TablePropertiesView, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      _get(_getPrototypeOf(TablePropertiesView.prototype), "render", this).call(this);
      // Enable the "submit" event for this view. It can be triggered by the #saveButtonView
      // which is of the "submit" DOM "type".
      submitHandler({
        view: this
      });
      // Maintain continuous focus cycling over views that have focusable children and focus cyclers themselves.
      [this.borderColorInput, this.backgroundInput].forEach(function (view) {
        view.fieldView.focusCycler.on('forwardCycle', function (evt) {
          _this2._focusCycler.focusNext();
          evt.stop();
        });
        view.fieldView.focusCycler.on('backwardCycle', function (evt) {
          _this2._focusCycler.focusPrevious();
          evt.stop();
        });
      });
      [this.borderStyleDropdown, this.borderColorInput, this.borderWidthInput, this.backgroundInput, this.widthInput, this.heightInput, this.alignmentToolbar, this.saveButtonView, this.cancelButtonView].forEach(function (view) {
        // Register the view as focusable.
        _this2._focusables.add(view);
        // Register the view in the focus tracker.
        _this2.focusTracker.add(view.element);
      });
      // Mainly for closing using "Esc" and navigation using "Tab".
      this.keystrokes.listenTo(this.element);
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(TablePropertiesView.prototype), "destroy", this).call(this);
      this.focusTracker.destroy();
      this.keystrokes.destroy();
    }
    /**
     * Focuses the fist focusable field in the form.
     */
  }, {
    key: "focus",
    value: function focus() {
      this._focusCycler.focusFirst();
    }
    /**
     * Creates the following form fields:
     *
     * * {@link #borderStyleDropdown},
     * * {@link #borderWidthInput},
     * * {@link #borderColorInput}.
     */
  }, {
    key: "_createBorderFields",
    value: function _createBorderFields() {
      var _this3 = this;
      var defaultTableProperties = this.options.defaultTableProperties;
      var defaultBorder = {
        style: defaultTableProperties.borderStyle,
        width: defaultTableProperties.borderWidth,
        color: defaultTableProperties.borderColor
      };
      var colorInputCreator = getLabeledColorInputCreator({
        colorConfig: this.options.borderColors,
        columns: 5,
        defaultColorValue: defaultBorder.color,
        colorPickerConfig: this.options.colorPickerConfig
      });
      var locale = this.locale;
      var t = this.t;
      var accessibleLabel = t('Style');
      // -- Group label ---------------------------------------------
      var borderRowLabel = new LabelView(locale);
      borderRowLabel.text = t('Border');
      // -- Style ---------------------------------------------------
      var styleLabels = getBorderStyleLabels(t);
      var borderStyleDropdown = new LabeledFieldView(locale, createLabeledDropdown);
      borderStyleDropdown.set({
        label: accessibleLabel,
        class: 'ck-table-form__border-style'
      });
      borderStyleDropdown.fieldView.buttonView.set({
        ariaLabel: accessibleLabel,
        ariaLabelledBy: undefined,
        isOn: false,
        withText: true,
        tooltip: accessibleLabel
      });
      borderStyleDropdown.fieldView.buttonView.bind('label').to(this, 'borderStyle', function (value) {
        return styleLabels[value ? value : 'none'];
      });
      borderStyleDropdown.fieldView.on('execute', function (evt) {
        _this3.borderStyle = evt.source._borderStyleValue;
      });
      borderStyleDropdown.bind('isEmpty').to(this, 'borderStyle', function (value) {
        return !value;
      });
      addListToDropdown(borderStyleDropdown.fieldView, getBorderStyleDefinitions(this, defaultBorder.style), {
        role: 'menu',
        ariaLabel: accessibleLabel
      });
      // -- Width ---------------------------------------------------
      var borderWidthInput = new LabeledFieldView(locale, createLabeledInputText);
      borderWidthInput.set({
        label: t('Width'),
        class: 'ck-table-form__border-width'
      });
      borderWidthInput.fieldView.bind('value').to(this, 'borderWidth');
      borderWidthInput.bind('isEnabled').to(this, 'borderStyle', isBorderStyleSet);
      borderWidthInput.fieldView.on('input', function () {
        _this3.borderWidth = borderWidthInput.fieldView.element.value;
      });
      // -- Color ---------------------------------------------------
      var borderColorInput = new LabeledFieldView(locale, colorInputCreator);
      borderColorInput.set({
        label: t('Color'),
        class: 'ck-table-form__border-color'
      });
      borderColorInput.fieldView.bind('value').to(this, 'borderColor');
      borderColorInput.bind('isEnabled').to(this, 'borderStyle', isBorderStyleSet);
      borderColorInput.fieldView.on('input', function () {
        _this3.borderColor = borderColorInput.fieldView.value;
      });
      // Reset the border color and width fields depending on the `border-style` value.
      this.on('change:borderStyle', function (evt, name, newValue, oldValue) {
        // When removing the border (`border-style:none`), clear the remaining `border-*` properties.
        // See: https://github.com/ckeditor/ckeditor5/issues/6227.
        if (!isBorderStyleSet(newValue)) {
          _this3.borderColor = '';
          _this3.borderWidth = '';
        }
        // When setting the `border-style` from `none`, set the default `border-color` and `border-width` properties.
        if (!isBorderStyleSet(oldValue)) {
          _this3.borderColor = defaultBorder.color;
          _this3.borderWidth = defaultBorder.width;
        }
      });
      return {
        borderRowLabel: borderRowLabel,
        borderStyleDropdown: borderStyleDropdown,
        borderColorInput: borderColorInput,
        borderWidthInput: borderWidthInput
      };
    }
    /**
     * Creates the following form fields:
     *
     * * {@link #backgroundInput}.
     */
  }, {
    key: "_createBackgroundFields",
    value: function _createBackgroundFields() {
      var _this4 = this;
      var locale = this.locale;
      var t = this.t;
      // -- Group label ---------------------------------------------
      var backgroundRowLabel = new LabelView(locale);
      backgroundRowLabel.text = t('Background');
      // -- Background color input -----------------------------------
      var backgroundInputCreator = getLabeledColorInputCreator({
        colorConfig: this.options.backgroundColors,
        columns: 5,
        defaultColorValue: this.options.defaultTableProperties.backgroundColor,
        colorPickerConfig: this.options.colorPickerConfig
      });
      var backgroundInput = new LabeledFieldView(locale, backgroundInputCreator);
      backgroundInput.set({
        label: t('Color'),
        class: 'ck-table-properties-form__background'
      });
      backgroundInput.fieldView.bind('value').to(this, 'backgroundColor');
      backgroundInput.fieldView.on('input', function () {
        _this4.backgroundColor = backgroundInput.fieldView.value;
      });
      return {
        backgroundRowLabel: backgroundRowLabel,
        backgroundInput: backgroundInput
      };
    }
    /**
     * Creates the following form fields:
     *
     * * {@link #widthInput},
     * * {@link #heightInput}.
     */
  }, {
    key: "_createDimensionFields",
    value: function _createDimensionFields() {
      var _this5 = this;
      var locale = this.locale;
      var t = this.t;
      // -- Label ---------------------------------------------------
      var dimensionsLabel = new LabelView(locale);
      dimensionsLabel.text = t('Dimensions');
      // -- Width ---------------------------------------------------
      var widthInput = new LabeledFieldView(locale, createLabeledInputText);
      widthInput.set({
        label: t('Width'),
        class: 'ck-table-form__dimensions-row__width'
      });
      widthInput.fieldView.bind('value').to(this, 'width');
      widthInput.fieldView.on('input', function () {
        _this5.width = widthInput.fieldView.element.value;
      });
      // -- Operator ---------------------------------------------------
      var operatorLabel = new View(locale);
      operatorLabel.setTemplate({
        tag: 'span',
        attributes: {
          class: ['ck-table-form__dimension-operator']
        },
        children: [{
          text: '×'
        }]
      });
      // -- Height ---------------------------------------------------
      var heightInput = new LabeledFieldView(locale, createLabeledInputText);
      heightInput.set({
        label: t('Height'),
        class: 'ck-table-form__dimensions-row__height'
      });
      heightInput.fieldView.bind('value').to(this, 'height');
      heightInput.fieldView.on('input', function () {
        _this5.height = heightInput.fieldView.element.value;
      });
      return {
        dimensionsLabel: dimensionsLabel,
        widthInput: widthInput,
        operatorLabel: operatorLabel,
        heightInput: heightInput
      };
    }
    /**
     * Creates the following form fields:
     *
     * * {@link #alignmentToolbar}.
     */
  }, {
    key: "_createAlignmentFields",
    value: function _createAlignmentFields() {
      var locale = this.locale;
      var t = this.t;
      // -- Label ---------------------------------------------------
      var alignmentLabel = new LabelView(locale);
      alignmentLabel.text = t('Alignment');
      // -- Toolbar ---------------------------------------------------
      var alignmentToolbar = new ToolbarView(locale);
      alignmentToolbar.set({
        isCompact: true,
        ariaLabel: t('Table alignment toolbar')
      });
      fillToolbar({
        view: this,
        icons: ALIGNMENT_ICONS,
        toolbar: alignmentToolbar,
        labels: this._alignmentLabels,
        propertyName: 'alignment',
        defaultValue: this.options.defaultTableProperties.alignment
      });
      return {
        alignmentLabel: alignmentLabel,
        alignmentToolbar: alignmentToolbar
      };
    }
    /**
     * Creates the following form controls:
     *
     * * {@link #saveButtonView},
     * * {@link #cancelButtonView}.
     */
  }, {
    key: "_createActionButtons",
    value: function _createActionButtons() {
      var locale = this.locale;
      var t = this.t;
      var saveButtonView = new ButtonView(locale);
      var cancelButtonView = new ButtonView(locale);
      var fieldsThatShouldValidateToSave = [this.borderWidthInput, this.borderColorInput, this.backgroundInput, this.widthInput, this.heightInput];
      saveButtonView.set({
        label: t('Save'),
        icon: icons.check,
        class: 'ck-button-save',
        type: 'submit',
        withText: true
      });
      saveButtonView.bind('isEnabled').toMany(fieldsThatShouldValidateToSave, 'errorText', function () {
        for (var _len = arguments.length, errorTexts = new Array(_len), _key = 0; _key < _len; _key++) {
          errorTexts[_key] = arguments[_key];
        }
        return errorTexts.every(function (errorText) {
          return !errorText;
        });
      });
      cancelButtonView.set({
        label: t('Cancel'),
        icon: icons.cancel,
        class: 'ck-button-cancel',
        withText: true
      });
      cancelButtonView.delegate('execute').to(this, 'cancel');
      return {
        saveButtonView: saveButtonView,
        cancelButtonView: cancelButtonView
      };
    }
    /**
     * Provides localized labels for {@link #alignmentToolbar} buttons.
     */
  }, {
    key: "_alignmentLabels",
    get: function get() {
      var locale = this.locale;
      var t = this.t;
      var left = t('Align table to the left');
      var center = t('Center table');
      var right = t('Align table to the right');
      // Returns object with a proper order of labels.
      if (locale.uiLanguageDirection === 'rtl') {
        return {
          right: right,
          center: center,
          left: left
        };
      } else {
        return {
          left: left,
          center: center,
          right: right
        };
      }
    }
  }]);
  return TablePropertiesView;
}(View);
export { TablePropertiesView as default };
function isBorderStyleSet(value) {
  return value !== 'none';
}